<template>
  <button :disabled="isDisabled" :class="[typeClasses, { 'button-wrapper-disabled': isDisabled }]" class="button-wrapper p-relative w-100 bg-brand-primary text-medium text-b16">
    <div v-if="!isDisabled" class="button-wrapper-hover p-absolute w-100 h-100"></div>
    <div class="button-wrapper-slot">
      <div v-if="loading" class="d-flex justify-center items-center">
        <BaseLoading :size="18"></BaseLoading>
      </div>
      <template v-else>
        <div class="d-flex justify-center items-center gap-8">
          <slot></slot>
        </div>
      </template>
    </div>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import BaseLoading from '@/components/base/loading/index.vue';
import type { ButtonProps } from '@/types';

const props = withDefaults(defineProps<ButtonProps>(), {
  type: 'primary',
});

const isDisabled = computed(() => props.disabled || props.loading);

const typeClasses = computed(() => {
  switch (props.type) {
    case 'primary':
      return 'bg-brand-secondary color-brand-secondary-text';
    case 'outlined':
      return 'outline color-link bg-cont-white';
    case 'outlined-dim':
      return 'outline-dim bg-cont-white';
    case 'text':
      return 'bg-cont-white text';
    default:
      return 'bg-cont-dim';
  }
});
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
